import { render, staticRenderFns } from "./GiveOngoingFeedback.vue?vue&type=template&id=34e74a48&lang=html&"
import script from "./GiveOngoingFeedback.vue?vue&type=script&lang=js&"
export * from "./GiveOngoingFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports